var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("Termos e Condições"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Regras gerais"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Nosso site é restrito exclusivamente a indivíduos maiores de idade, conforme determinado pela legislação da jurisdição em que o indivíduo reside. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Nosso site não se responsabiliza por quaisquer leis nacionais, federais ou internacionais infringidas por usuários que utilizem nosso site. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Os usuários são responsáveis ​​por seus próprios atos e estão sujeitos às leis de seus respectivos países, incluindo leis estaduais e questões legais. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Todos os agentes são responsáveis ​​pelas contas de seus respectivos membros e devem honrar todas as apostas confirmadas por eles enviadas. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Os agentes não são parceiros do nosso site. Portanto, o nosso site não se responsabiliza por quaisquer discrepâncias ou disputas entre jogadores e agentes. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " É responsabilidade do usuário proteger seu ID de usuário e senha contra uso não autorizado. Caso o ID de usuário e a senha sejam roubados ou comprometidos, é responsabilidade do usuário contatar seu agente imediatamente. O agente, então, alterará o ID de usuário e a senha para o usuário. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Em caso de roubo de ID de usuário e senha, o usuário é responsável por suas respectivas contas e deverá honrar todas as apostas confirmadas. "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Regras do Jogo"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Os resultados dos jogos definidos pelo nosso site serão finais e vinculativos. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Em todos os casos de disputa, tanto a administração do nosso site quanto o jogador devem concordar que o banco de dados de registro de transações do nosso site servirá como árbitro final na disputa. Todas as disputas devem ser registradas no mesmo dia em que o resultado da partida for determinado. Nenhuma reclamação será aceita após o dia da partida. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " O jogador é o único responsável por verificar a exatidão de todas as transações de sua conta. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Por favor, revise suas apostas cuidadosamente para verificar se há erros, enganos ou omissões antes de enviá-las pelo computador. Uma vez que uma aposta é aceita pelo computador, ela não pode ser alterada ou cancelada. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Reservamo-nos o direito de congelar ou cancelar a conta de qualquer cliente que viole estes Termos e Condições, se envolva em atividades fraudulentas, invasão de propriedade, agressão, falsificação, corrupção das regras padrão ou participação em apostas em grupo, sendo todos os saldos resultantes da conta congelados e confiscados sem aviso prévio. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Reservamo-nos o direito de anular ou cancelar qualquer aposta ou bilhete que esteja associado a apostas em grupo, apostas coordenadas, conluio, fraude, abuso do sistema, exploração de erros técnicos, probabilidades incorretas ou qualquer outra tentativa de obter vantagem injusta. Quaisquer ganhos relacionados poderão ser estornados e a conta correspondente poderá ser suspensa ou encerrada. "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Limites e responsabilidades"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Sem prejuízo da generalidade do exposto, o nosso website não será responsável perante qualquer pessoa em caso de sabotagem, força maior e/ou por eventos de falha, dano ou destruição do sistema informático central ou dos registos do nosso website, ou de qualquer parte dos mesmos, ou por atrasos, perdas, erros, omissões ou quaisquer outros resultantes de falhas em qualquer sistema de telecomunicações ou de transmissão de dados, ou por qualquer atraso que resulte na não receção de qualquer inscrição para uma determinada corrida. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Nosso site não será responsabilizado por quaisquer perdas resultantes de casos fortuitos ou de força maior, como conflitos armados, motins, distúrbios civis, atos de terrorismo, atos governamentais ou de autoridades (incluindo a recusa ou revogação de qualquer licença ou autorização), incêndios, explosões, inundações, roubos, danos dolosos, greves, bloqueios e ações industriais de qualquer tipo. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Em caso de falhas de conexão de rede, comunicação, sistema ou erros humanos que causem problemas relacionados a apostas, como apostas duplas aceitas, apostas não confirmadas, apostas feitas após o início do jogo, etc., reservamo-nos o direito de analisar cada caso individualmente e tomar as medidas necessárias para corrigi-los. Não nos responsabilizamos perante você ou terceiros por tais erros. Se você tiver sofrido esses erros e continuar apostando sem informar seu patrocinador, você será responsabilizado e terá que arcar com todos os resultados de ganhos/perdas caso os erros ocorram novamente. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Estas Regras e Regulamentos constituem o acordo e entendimento integral entre as partes. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " Caso haja alguma discrepância entre a versão em inglês destas Regras e Regulamentos e qualquer outra versão em outro idioma, a versão em inglês prevalecerá sobre as demais e será considerada correta e válida. "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }